import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      toast.error("Le password non coincidono");
      return;
    }
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password impostata. Ora puoi accedere.");
      navigate("/login");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-greige flex items-center justify-center px-6">
      <div className="w-full max-w-sm fade-up">
        <h1 className="font-display text-4xl tracking-tight text-ink">Imposta password</h1>
        <p className="meta-label mt-2 mb-12">TWOE CLOUD HUB</p>
        <form onSubmit={submit} className="space-y-7">
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Nuova password (min 8 caratteri)"
            required
            minLength={8}
            data-testid="reset-password-input"
            className="field-line"
          />
          <input
            type="password"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            placeholder="Conferma password"
            required
            data-testid="reset-confirm-input"
            className="field-line"
          />
          <button
            type="submit"
            disabled={busy}
            data-testid="reset-submit-button"
            className="w-full bg-black text-greige py-3.5 text-xs uppercase tracking-widest hover:bg-stone2e transition-colors disabled:opacity-60"
          >
            {busy ? "Salvataggio…" : "Salva password"}
          </button>
        </form>
      </div>
    </div>
  );
}
